export default __webpack_public_path__ + "static/media/Medium's Armbands of Secret Doors.84571289.jpg";